import { Store } from '@ngrx/store';
import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core'
import { map, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import { selectSettingsState } from './../../../store/settings/settings.selectors';
import { ApiServiceBase } from '../../base/api-service-base';
import { AuthService } from '../../authentication/auth.service';
import { SettingsManagementModel } from '../../models/reference-model/reference-general-model/settings-management.model';
import { take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SettingsManagementService extends ApiServiceBase implements OnDestroy {
    private readonly PATH = "/system/settingsmanagement"
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(httpClient: HttpClient,
        authService: AuthService, private store: Store<any>) {
        super(httpClient, authService);
    }

    public getAll(): Observable<SettingsManagementModel[]> {
        return this.httpGet<SettingsManagementModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }

    public getNavBarMinifyState(): boolean {
        let minifyState;
        this.store.select(selectSettingsState).pipe(
            takeUntil(this.destroy$))
            .subscribe(state => {
                minifyState = state.minifyNavigation
            })
        return minifyState;
    }

    public observeMinifyState(): Observable<boolean> {
        return this.store.select(selectSettingsState)
            .pipe(
                take(1),
                map(state => state.minifyNavigation)
            )
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe()
    }

}